<template>
	<v-navigation-drawer
		id="core-navigation-drawer"
		v-model="drawer"
		:dark="true"
		mobile-breakpoint="960"
		app
		width="260"
	>
		<v-list-item two-line v-if="client">
			<v-list-item-content>
				<v-list-item-title class="font-weight-regular text-h3">
					<v-btn
						v-if="client.Logo"
						@click="showClientDialog"
						style="
							background-color: transparent;
							min-height: 41px;
							height: auto;
						"
					>
						<v-img
							v-if="client.Logo"
							class="mx-auto"
							:src="getLogoUrl(client.Logo)"
							style="max-height: 200px; max-width: 200px"
						/>
					</v-btn>
					<v-btn
						style="width: 100%"
						class="secondary"
						v-else
						@click="showClientDialog"
					>
						{{ client.Name || '' }}
					</v-btn>
				</v-list-item-title>
			</v-list-item-content>
		</v-list-item>

		<v-list-item two-line v-if="project">
			<v-list-item-content>
				<v-btn
					v-if="project.Logo"
					@click="showProjectDialog"
					style="
						background-color: transparent;
						min-height: 41px;
						height: auto;
					"
				>
					<v-img
						v-if="project.Logo"
						class="mx-auto"
						:src="getLogoUrl(project.Logo)"
						style="max-height: 200px; max-width: 200px"
					/>
				</v-btn>
				<v-btn
					v-else
					@click="showProjectDialog"
					class="primary"
					style="width: 100%"
					>{{ project.Name || '' }}</v-btn
				>
			</v-list-item-content>
		</v-list-item>

		<v-divider class="mb-2" />

		<v-list expand nav>
			<template v-for="(item, i) in computedItems">
				<base-item-group
					v-if="item.children"
					:key="`group-${i}`"
					:item="item"
					textColor="white"
				/>
				<base-item v-else :key="`item-${i}`" :item="item" />
			</template>
		</v-list>

		<v-divider class="mb-2" />

		<v-list expand nav>
			<template v-for="(item, i) in adminMenuItems">
				<base-item-group
					v-if="item.children"
					:key="`group-${i}`"
					:item="item"
					textColor="white"
				/>
				<base-item v-else :key="`item-${i}`" :item="item" />
			</template>
		</v-list>
		<select-project-modal
			v-if="showSelectProjectModal"
			:showDialog="showSelectProjectModal"
			@cancel="hideProjectDialog"
			@submit="hideProjectDialog"
		/>
		<select-client-modal
			v-if="showSelectClientModal"
			:showDialog="showSelectClientModal"
			@cancel="hideClientDialog"
			@submit="hideClientDialog"
		/>
	</v-navigation-drawer>
</template>

<script>
// Utilities
import BaseItem from '@/components/base/ItemAnchor';
import BaseItemGroup from '@/components/base/ItemGroup';

import { mapGetters } from 'vuex';
import { GeneralActions } from '@/store/actions';
import {
	GeneralGetters,
	ProjectSettingsGetters,
	ClientContextGetters,
	ProjectContextGetters,
	ClientManagementGetters,
	ProjectManagementGetters,
	GridsGetters,
	InventoryFormGetters,
	ActivityGetters,
} from '@/store/getters';

import SelectProjectModal from '../userContext/SelectProjectModal.vue';
import SelectClientModal from '../userContext/SelectClientModal.vue';
import permissionsMixin from '../../mixins/menuPermissionMixin';

import { InventoryFormTypes } from '../../enums/inventoryFormTypes';
import vueAppSubfolder from '../../utils/appSubfolderUtils';

export default {
	name: 'LayoutDrawer',
	components: {
		BaseItem,
		BaseItemGroup,
		SelectProjectModal,
		SelectClientModal,
	},
	mixins: [permissionsMixin],

	data() {
		return {
			showSelectClientModal: false,
			showSelectProjectModal: false,
			items: [],
		};
	},
	computed: {
		...mapGetters({
			drawerState: [GeneralGetters.DRAWER],
			client: [ClientContextGetters.SELECTED_CLIENT],
			project: [ProjectContextGetters.SELECTED_PROJECT],
			allProjects: [ProjectContextGetters.PROJECTS],

			clientsManagement: [ClientManagementGetters.INITIALIZED],
			projectManagement: [ProjectManagementGetters.INITIALIZED],

			projectSettings: [ProjectSettingsGetters.INITIALIZED],

			gridsModule: [GridsGetters.INITIALIZED],
			gridsMenuEntities: [GridsGetters.GET_MENU_ENTITIES],

			inventoryFormsModule: [InventoryFormGetters.INITIALIZED],
			inventoryFormsMenuEntities: [InventoryFormGetters.MENU_FORMS],

			activities: [ActivityGetters.ACTIVITIES],
		}),

		drawer: {
			get() {
				return this.drawerState;
			},
			set(isToggled) {
				this.$store.dispatch(
					GeneralActions.UPDATE_DRAWER_STATE,
					isToggled
				);
			},
		},

		computedItems() {
			let items = [];
			if (this.homePageMenu) {
				items = this.apppendMenuItems(items, this.homePageMenu, 0);
			}

			if (this.gridsModuleMenu && this.canViewGrids) {
				items = this.apppendMenuItems(items, this.gridsModuleMenu, 2);
			}

			if (this.inventoryModuleMenu && this.canViewInventory) {
				items = this.apppendMenuItems(
					items,
					this.inventoryModuleMenu,
					3
				);
			}
			//TODO PERMISSIONS
			if (this.activitiesMenu && this.canViewActivity) {
				items = this.apppendMenuItems(items, this.activitiesMenu, 1);
			}
			if (this.reportsMenu && this.canViewReports) {
				items = this.apppendMenuItems(items, this.reportsMenu, 5);
			}

			if (this.toolsMenu && this.canViewTools) {
				items = this.apppendMenuItems(items, this.toolsMenu, 6);
			}

			if (this.settingsMenu && this.canViewSettings) {
				items = this.apppendMenuItems(items, this.settingsMenu, 7);
			}

			return items;
		},
		homePageMenu() {
			let item = { icon: 'mdi-home', title: 'Homepage', to: '/homepage' };
			return item;
		},

		reportsMenu() {
			let item = {
				icon: 'mdi-chart-box-outline',
				title: 'Reports',
				to: '/reports',
			};
			return item;
			// let children = [];
			// this.reports.forEach((item) => {
			//     children = this.apppendMenuItems(
			//         children,
			//         {
			//             icon: "mdi-chart-box-outline",
			//             title: item.ReportName,
			//             to: `${item.ReportId}/gridView/${item.GridViewId}`,
			//         },
			//         0
			//     );
			// });
			// if (children.length > 0) {
			//     let item = {
			//         group: "/reports",
			//         icon: "mdi-chart-box-plus-outline",
			//         title: "Reports",
			//         children: children.sort((a, b) =>
			//             a.title > b.title ? 1 : -1
			//         ),
			//     };
			//     return item;
			// }
			// return null;
		},

		gridsModuleMenu() {
			if (this.gridsModule) {
				let children = [];
				this.gridsMenuEntities.forEach((entity) => {
					switch (entity.Name) {
						case 'Asset':
							children = this.apppendMenuItems(
								children,
								{
									icon: 'mdi-file-multiple',
									title: 'Assets',
									to: entity.Name,
								},
								0
							);
							break;
						case 'Catalog':
							children = this.apppendMenuItems(
								children,
								{
									icon: 'mdi-tag-multiple',
									title: 'Catalogs',
									to: entity.Name,
								},
								1
							);
							break;
						case 'Department':
							children = this.apppendMenuItems(
								children,
								{
									icon: 'mdi-vector-polyline',
									title: 'Departments',
									to: entity.Name,
								},
								2
							);
							break;
						case 'Name':
							children = this.apppendMenuItems(
								children,
								{
									icon: 'mdi-account-plus',
									title: 'End-User Names',
									to: entity.Name,
								},
								3
							);
							break;
						case 'Location':
							children = this.apppendMenuItems(
								children,
								{
									icon: 'mdi-map-marker-multiple',
									title: 'Locations',
									to: entity.Name,
								},
								4
							);
							break;
						default:
							children.push({
								icon: 'mdi-view-grid-outline',
								title: entity.Name,
								to: entity.Name,
							});
							break;
					}
				});
				if (children.length > 0) {
					let item = {
						group: '/grids',
						icon: 'mdi-grid',
						title: 'Datasets',
						children: children.sort((a, b) =>
							a.title > b.title ? 1 : -1
						),
						permissionsNeeded: [],
					};
					return item;
				}
			}
			return null;
		},

		inventoryModuleMenu() {
			if (this.inventoryFormsModule) {
				let children = [];
				this.inventoryFormsMenuEntities.forEach((item) => {
					if (item.Type === InventoryFormTypes.Inventory)
						children = this.apppendMenuItems(
							children,
							{
								icon: 'mdi-file-document-edit',
								title: item.Name,
								to: `${item.Id}/form`,
							},
							0
						);
					else
						children = this.apppendMenuItems(
							children,
							{
								icon: 'mdi-file-document-edit',
								title: item.Name,
								to: `${item.Id}/grid`,
							},
							0
						);
				});
				if (children.length > 0) {
					let item = {
						group: '/inventory',
						icon: 'mdi-clipboard-text-outline',
						title: 'Inventory',
						children: children.sort((a, b) =>
							a.title > b.title ? 1 : -1
						),
					};
					return item;
				}
			}
			return null;
		},
		activitiesMenu() {
			let children = [];
			this.activities.forEach((item) => {
				children = this.apppendMenuItems(
					children,
					{
						icon: 'mdi-calendar-month-outline',
						title: item.Name,
						to: `${item.Id}`,
					},
					0
				);
			});
			if (children.length > 0) {
				let item = {
					group: '/activity',
					icon: 'mdi-calendar-month-outline',
					title: 'Activities',
					children: children.sort((a, b) =>
						a.title > b.title ? 1 : -1
					),
				};
				return item;
			}
			return null;
		},
		toolsMenu() {
			let formBuilder = {
				icon: 'mdi-text-box-plus',
				title: 'Form builder',
				to: 'form-builder',
			};
			let activityBuilder = {
				icon: 'mdi-calendar-plus',
				title: 'Activity builder',
				to: 'activity-builder',
			};

			let reportBuilder = {
				icon: 'mdi-chart-box-plus-outline',
				title: 'Report builder',
				to: 'report-builder',
			};
			let dataImport = {
				icon: 'mdi-database-import',
				title: 'Data import',
				to: 'data-import',
			};
			let dataExport = {
				icon: 'mdi-file-export',
				title: 'Exports',
				to: 'data-exports',
			};
			let referenceList = {
				icon: 'mdi-form-dropdown',
				title: 'Reference Lists',
				to: 'reference-lists',
				permissionsNeeded: [],
			};
			let projectClone = {
				icon: 'mdi-content-duplicate',
				title: 'Clone Project',
				to: 'clone-project',
			};
			let children = [];
			if (this.canViewFormBuilder) {
				children = this.apppendMenuItems(children, formBuilder, 0);
			}
			if (this.canViewReportBuilder) {
				children = this.apppendMenuItems(children, reportBuilder, 1);
			}
			if (this.canViewDataImport) {
				children = this.apppendMenuItems(children, dataImport, 2);
			}
			if (this.canViewExport) {
				children = this.apppendMenuItems(children, dataExport, 3);
			}
			if (this.canViewReferenceLists)
				children = this.apppendMenuItems(children, referenceList, 4);
			if (this.canViewActivityBuilder)
				children = this.apppendMenuItems(children, activityBuilder, 5);
			if (this.canViewProjectClone) {
				children = this.apppendMenuItems(children, projectClone, 6);
			}

			let item = {
				group: '/tools',
				icon: 'mdi-hammer-wrench',
				title: 'Tools',
				children: children.sort((a, b) => (a.title > b.title ? 1 : -1)),
			};

			return item;
		},

		settingsMenu() {
			if (this.gridsModule || this.projectSettings) {
				let dataField = {
					icon: 'mdi-database-cog',
					title: 'Database tables',
					to: 'data-fields',
					permissionsNeeded: [],
				};
				let userManagement = {
					icon: 'mdi-account-group',
					title: 'User management',
					to: 'user-management',
				};
				let gridFields = {
					icon: 'mdi-view-grid',
					title: 'Dataset fields',
					to: 'grid-fields',
					permissionsNeeded: [],
				};
				let generalSettings = {
					icon: 'mdi-cogs',
					title: 'General',
					to: 'general-settings',
					permissionsNeeded: [],
				};
				// let mergeConditions = {
				// 	icon: 'mdi-call-merge',
				// 	title: 'Merge Conditions',
				// 	to: 'merge-conditions',
				// 	permissionsNeeded: [],
				// };
				let connectors = {
					icon: 'mdi-connection',
					title: 'Dataset connectors',
					to: 'connectors',
					permissionsNeeded: [],
				};

				let children = [];
				if (this.projectSettings) {
					if (this.canViewGeneralSettings)
						children = this.apppendMenuItems(
							children,
							generalSettings,
							0
						);
					if (this.canViewDataFields) {
						children = this.apppendMenuItems(
							children,
							dataField,
							1
						);
					}
					if (this.canViewUserManagement) {
						children = this.apppendMenuItems(
							children,
							userManagement,
							2
						);
					}
					/*if (this.canViewMergeConditions)
						children = this.apppendMenuItems(
							children,
							mergeConditions,
							4
						);*/
					children = this.apppendMenuItems(children, connectors, 5);
				}

				if (this.gridsModule) {
					if (this.canViewGridFields) {
						children = this.apppendMenuItems(
							children,
							gridFields,
							3
						);
					}
				}

				let item = {
					group: '/settings',
					icon: 'mdi-cog',
					title: 'Settings',
					children: children.sort((a, b) =>
						a.title > b.title ? 1 : -1
					),
				};

				return item;
			}

			return null;
		},

		adminMenuItems() {
			let items = [];
			if (this.clientsManagement && this.canViewClients) {
				let item = {
					icon: 'mdi-account-multiple',
					title: 'Clients',
					to: '/clients-management',
				};
				if (items.length === 0) {
					items.push(item);
				} else {
					items.splice(0, 0, item);
				}
			}

			if (this.projectManagement && this.canViewProjectsMenu) {
				let item = {
					icon: 'mdi-file',
					title: 'Projects',
					to: '/projects-management',
				};
				items.push(item);
			}
			return items;
		},
	},

	methods: {
		showProjectDialog() {
			this.showSelectProjectModal = true;
		},
		showClientDialog() {
			this.showSelectClientModal = true;
		},
		hideProjectDialog() {
			this.showSelectProjectModal = false;
		},
		hideClientDialog() {
			this.showSelectClientModal = false;
		},

		getLogoUrl(image) {
			let path =
				window.location.origin +
				(vueAppSubfolder.get() === '/' ? '' : vueAppSubfolder.get()) +
				'/uploads';
			path = path + image;
			return path;
		},

		apppendMenuItems(items, menuItem, defaultPosition) {
			if (items.length > defaultPosition) {
				items.splice(defaultPosition, 0, menuItem);
			} else {
				items.push(menuItem);
			}
			return items;
		},
	},
};
</script>

<style></style>
